import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import HeroBase, * as HeroSection from '@segment/matcha/recipes/Hero'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const copy = {
  overline: `Twilio + Segment`,
  heading: `Create intelligent customer engagement across every channel`,
}

const cta = {
  text: `Sign up and start building`,
  url: `https://www.twilio.com/try-twilio/?utm_source=segment&utm_medium=referral&utm_campaign=segment_better_together&utm_content=twilio_landing`,
}

const Hero: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <StyledHeroBase copyVariant="wide" variant="centered">
        <StyledHeroSectionCopy>
          <StyledCopyTextBase centered={true}>
            <CopyText.Overline tag="h5">{copy.overline}</CopyText.Overline>
            <StyledCopyHeading tag="h1" variant="h1">
              {copy.heading}
            </StyledCopyHeading>
            <Button tag="a" href={cta.url} size="large" variant="filled" color="primary" iconEnd={ChevronRightIcon}>
              {cta.text}
            </Button>
          </StyledCopyTextBase>
        </StyledHeroSectionCopy>
      </StyledHeroBase>
    </Wrapper>
  )
}

const StyledHeroBase = styled(HeroBase)`
  ${HeroSection.Wrapper} {
    gap: 0;
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-bottom: 80px;
    }
  }
`

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const StyledHeroSectionCopy = styled(HeroSection.Copy)`
  max-width: 740px;
`

const StyledCopyHeading = styled(CopyText.Heading)`
  padding-bottom: 24px;
`

const StyledCopyTextBase = styled(CopyTextBase)`
  max-width: 940px;
`

export default Hero
